import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** cn menggabungkan kelas Tailwind sambil membuang yang saling bertabrakan. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
